import {
      HomeOgImage,
      DevopsConsultingServicesOgImage,
      DigitalTransformationOgImage,
      HireDedicatedMobileWebDevelopersOgImage,
      InternetOfThingsIotApplicationsOgImage,
      MobileApplicationDevelopmentOgImage,
      MvpDevelopmentCompanyOgImage,
      ProductEngineeringServicesOgImage,
      SaasDevelopmentCompanyOgImage,
      SoftwareDevelopmentCompanyOgImage,
      WebApplicationDevelopmentOgImage,
      PortugalStrategicPartnershipImage,
      AngularjsDevelopmentOgImage,
      DotNetDevelopmentOgImage,
      FinancialSoftwareDevelopmentOgImage,
      HealthcareSoftwareDevelopmentOgImage,
      JavaDevelopmentOgImage,
      LogisticsSoftwareDevelopmentOgImage,
      NodejsdevelopmentOgImage,
      PHPWebDevelopmentOgImage,
      PythonDevelopmentOgImage,
      ReactDevelopmentOgImage,
      VuejsDevelopmentOgImage,
      AndroidApplicationDevelopmentOgImage,
      DjangoDevelopmentOgImage,
      FlutterAppDevelopmentOgImage,
      IosApplicationDevelopmentOgImage,
      LaravelDevelopmentOgImage,
      MeanStackDevelopmentOgImage,
      MernStackDevelopmentOgImage,
      ReactNativeDevelopmentOgImage,
      XamarinMobileApplicationDevelopmentOgImage,
      PatientRegistrySoftwareDevelopmentOgImage,
      TelemedicineAppDevelopmentOgImage,
      HealthcareIotSolutionsOgImage,
      MobilebankingOgImage,
      MhealthappOgImage,
      CrossBorderRemittanceSoftwareDevelopmentOgImage,
      EwalletappdevelopmentOgImage,
      MerchantPaymentServicesOgImage,
      RemotePatientMonitoringSolutionsOgImage,
      PatientEngagementSoftwareDevelopmentOgImage,
      SocialDefaultImage
} from "../utils/imageConst";

export const HomeMeta = {
      metaTitle: `Custom Software Development Company India, USA - Peerbits`,
      metaDescription: "Peerbits is a trusted Custom Software Development company India, USA. We build robust software, mobile apps and web apps for versatile niches across the globe.",
      ogTitle: "",
      ogDescription: "",
      ogType: "website",
      ogSiteName: "",
      ogImage: HomeOgImage,
      twitterCard: "",
      twitterCreator: "",
      twitterTitle: "",
      twitterDescription: "",
      twitterImage: HomeOgImage
};

export const PortfolioMeta = {
      metaTitle: `Helped 500+ Global Companies Transform Their Business`,
      metaDescription: "We empowered 500+ global companies to revolutionize their business. Discover our outstanding work & outcomes we delivered. Trust us for digital transformation.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const PortfolioCateroyMeta = {
      metaTitle: `Project Portfolio - Peerbits`,
      metaDescription: "With 12+ years of experience, Peerbtis is on a mission to build digital products our clients envisioned and enhance their potential.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const BlogMeta = {
      metaTitle: `Insightful blogs | Peerbits`,
      metaDescription: "Stay updated with the latest news and trends in mobile app & software development, IoT, Blockchain, and most latest technologies via our well-researched blogs.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const BlogCateroyMeta = {
      metaTitle: `Blogs by Peerbits`,
      metaDescription: "Explore Peerbits’ well-researched blogs and articles to access the latest trends, tips, news, updates, and expert insights.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const BlogAuthorMeta = {
      metaTitle: `Blogs by Peerbits`,
      metaDescription: "We have built web, apps, Mobile apps, enterprise software, and more. See the success stories of our global clients from across the industries.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ResourcesMeta = {
      metaTitle: `Meet the Expert Tech Resources - Peerbits`,
      metaDescription: "Expert our technology experts to build digital solution tailored to your business needs. Meet our team of experienced developers and bring your ideas to life.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ContactUsMeta = {
      metaTitle: `Fill Up the Form & Tell Us Your Requirements - Peerbits`,
      metaDescription: "You can request a quote anytime by filling up the form round the clock, or meet us by personally visiting in the office hours.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireReactjsDevelopersMeta = {
      metaTitle: `Hire Dedicated ReactJS Developers | Hire ReactJS Experts`,
      metaDescription: "Hire dedicated Reactjs developers to build modern and high-performing web apps for your business at a flexible hiring model. Hire remote react developers now.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireReactNativeDeveloperMeta = {
      metaTitle: `Hire Dedicated React Native Developers | Hire React Native Experts`,
      metaDescription: "Hire dedicated react native developers who are skilled at using latest framework and are expert in  top-notch and highly functional mobile apps development.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HirePythonDevelopersMeta = {
      metaTitle: `Hire Dedicated Python Developers | Hire Python Experts`,
      metaDescription: "Hire dedicated Python developers for your next project who will work as an extension to your in-house team. Hire only to get high-quality solutions on time.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireNodejsDevelopersMeta = {
      metaTitle: `Hire Dedicated NodeJS Developers | Hire NodeJS Experts`,
      metaDescription: "Hire top Node.js developers from Peerbits for on-time & budget-friendly development services with 14-days risk-free trial. Hire node.js developers now.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireJavaDevelopersMeta = {
      metaTitle: `Hire Dedicated Java Developers | Hire Java Experts`,
      metaDescription: "Hire top Java development team at 14 day risk free trial. Leverage our expert Java developers’ expertise at a competitive price & your achieve business goals.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireIosAppDeveloperMeta = {
      metaTitle: `Hire iOS App Developers | Hire iOS Experts - Peerbits`,
      metaDescription: "Hire expert iOS developers in India from Peerbits at a 14-day risk-free trial. Leverage our flexible hiring model and start building a futuristic native app.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireDotNetDevelopersMeta = {
      metaTitle: `Hire Dedicated Dot Net Developers | Hire .Net Experts`,
      metaDescription: "Hire dedicated .NET developers for your enterprise-grade software project from Peerbits at a 14-day risk-free trial. Get access to top rated dot net developers.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireAngularjsDevelopersMeta = {
      metaTitle: `Hire Dedicated AngularJS Developers | Hire Angular Experts`,
      metaDescription: "Hire best angular developers from Peerbits who apply top coding standards to deliver quality software for a wide range of industries at a competitive rate.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireVuejsDevelopersMeta = {
      metaTitle: `Hire Dedicated Vue.JS Developers | Hire Vue.JS Experts`,
      metaDescription: "Hire Vue.js developers to build high-performing, interactive and scalable web apps at affordable price. Get access to our experts at a 14-day risk-free trial.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireAndroidAppDeveloperMeta = {
      metaTitle: `Hire android app developers, Android application programmers`,
      metaDescription: "Hire best Android app developers from Peerbits on an hourly, part-time, or full-time basis. Utilize their expertise to build robust native apps across industry.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireFlutterAppDeveloperMeta = {
      metaTitle: `Hire Dedicated Flutter App Developers | Hire Flutter Experts`,
      metaDescription: "Hire dedicated Flutter app developers from Peerbits with vast experience, expertise, and dedication who deliver top-notch Flutter apps to global clients.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireXamarinAppDevelopersMeta = {
      metaTitle: `Hire Dedicated AngularJS Developers | Hire Flutter Experts`,
      metaDescription: "Hire expert xamarin app developers who will craft reliable cross platform apps using their tech expertise. Transform your business with our developers, easily.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireSymfonyFrameworkDevelopersMeta = {
      metaTitle: `Hire Dedicated Symfony Developers | Hire Symfony Experts`,
      metaDescription: "Peerbits is a leading Symfony development company that offers expert symfony developers for hire to start-ups and enterprises at affordable rate. ",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireDjangoDeveloperMeta = {
      metaTitle: `Hire Dedicated Django Developers | Hire Django Experts`,
      metaDescription: "Hire dedicated Django developers from Peerbits at 14 day risk free trial. Get top-rated Django development services at the lowest possible cost.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const HireLaravelDeveloperMeta = {
      metaTitle: `Hire Dedicated Laravel Developers | Hire Laravel Experts`,
      metaDescription: "Hire best laravel developers from Peerbits at your convenient engagement model. Leverage their skillset to create lightning-fast APIs for mobile and web apps.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireMeanStackDeveloperMeta = {
      metaTitle: `Hire Dedicated MEAN Stack Developers | Hire MEAN Experts`,
      metaDescription: "Hire dedicated MEAN stack developers from Peerbits & get access to India's top 1% top talent. Get top-notch MEAN stack development services at the lowest cost.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireMernStackDeveloperMeta = {
      metaTitle: `Hire Dedicated MERN Stack Developers | Hire MERN Experts`,
      metaDescription: "Hire MERN Stack developers from Peerbits at 14 day risk free trial who can efficiently work with all open-source components of MERN. Hire at your choice.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const processMeta = {
      metaTitle: `Agile Software Development Process - Peerbits`,
      metaDescription: "Peerbits follow custom robust software development process to deliver high quality solutions on timely manner. We follow agile development methods.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const OurStoryMeta = {
      metaTitle: `Peerbits Story - A Journey of Success in Tech World`,
      metaDescription: "Discover the story of Peerbits - A software development company. Learn how we help businesses innovate and grow with cutting-edge tech solutions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const EngagementModelMeta = {
      metaTitle: `Engagement model - Peerbits`,
      metaDescription: "We offer flexible mobile app services engagement model to our clients. As per client’s preferences and requirements, engagement models are consulted.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const LifeAtPeerbitsMeta = {
      metaTitle: `Life at Peerbits is full of opportunities, learning`,
      metaDescription: "Join Peerbits to skyrocket your career with excellent growth opportunities in a dynamic environment which promotes excellence, innovation, and growth.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const CareersMeta = {
      metaTitle: `Careers | Jobs | Careers@Peerbits | Jobs@Peerbits`,
      metaDescription: "Build a career working with Peerbits brighten your future. Apply for job openings by emailing your updated resume or CV to career@peerbits.com.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const TestimonialsMeta = {
      metaTitle: `Reviews and Testimonials from Our Global Clients - Peerbits`,
      metaDescription: "Reviews & Testimonials from Global Clients at Peerbits. See what our satisfied customers have to say about our services. Visit us now!",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const MobileApplicationDevelopmentMeta = {
      metaTitle: `Mobile App Development Company India, USA - Peerbits`,
      metaDescription: "Peerbits is a top mobile app development company in India, USA offering full cycle mobile app design & development services across the globe at affordable rate.",
      ogImage: MobileApplicationDevelopmentOgImage,
      twitterImage: MobileApplicationDevelopmentOgImage
};

export const SoftwareDevelopmentCompanyMeta = {
      metaTitle: `Custom Software Development Consulting & Services Company USA`,
      metaDescription: "Peerbits is a reliable Custom software development company serving global clients since 12+ years. 150+ IT professionals dedicated to deliver best software.",
      ogImage: SoftwareDevelopmentCompanyOgImage,
      twitterImage: SoftwareDevelopmentCompanyOgImage
};

export const DevopsConsultingServicesMeta = {
      metaTitle: `DevOps Consulting and Implementation Services - Peerbits`,
      metaDescription: "Expert DevOps consulting services from Peerbits to optimize your software delivery pipeline, IT operations, and improve performance. Contact us now to get started.",
      ogImage: DevopsConsultingServicesOgImage,
      twitterImage: DevopsConsultingServicesOgImage
};

export const HireDedicatedMobileWebDevelopersTeamMeta = {
      metaTitle: `Hire Dedicated Web & App developers| Hire app experts`,
      metaDescription: "Hire dedicated web & app developers from Peerbits who are skilled in different niches and technologies. Extend your team and scale your business, effortlessly.",
      ogImage: HireDedicatedMobileWebDevelopersOgImage,
      twitterImage: HireDedicatedMobileWebDevelopersOgImage
};

export const IosApplicationDevelopmentMeta = {
      metaTitle: `Custom iOS App Development Company India, USA - Peerbits`,
      metaDescription: "Peerbits is a leading iOS app development company in USA, offers custom iOS & iphone apps development services for entrepreneurs & small businesses.",
      ogImage: IosApplicationDevelopmentOgImage,
      twitterImage: IosApplicationDevelopmentOgImage
};

export const AndroidApplicationDevelopmentMeta = {
      metaTitle: `Best Custom Android App Development Company USA - Peerbits`,
      metaDescription: "Peerbits is a top Android App Development Company in India & USA, providing exceptional Android application development services to enhance your business goals.",
      ogImage: AndroidApplicationDevelopmentOgImage,
      twitterImage: AndroidApplicationDevelopmentOgImage
};

export const WebApplicationDevelopmentMeta = {
      metaTitle: `Custom Web App Development Services Company India, USA`,
      metaDescription: "Peerbits is a leading web app development company India, USA. We provide custom web design & development services using modern technologies at affordable cost.",
      ogImage: WebApplicationDevelopmentOgImage,
      twitterImage: WebApplicationDevelopmentOgImage
};

export const CloudOptimisationMeta = {
      metaTitle: `Cloud Optimization Services | Peerbits`,
      metaDescription: "Maximize your enterprise efficiency & performance with our Cloud Optimization Services. Save cost and time by optimizing your cloud resources for optimal usage.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const CloudMigrationMeta = {
      metaTitle: `Cloud migration services and solutions - Peerbits`,
      metaDescription: "Our AWS certified experts offer total cloud migration services including migrating databases, servers, and using AWS Migration Hub for maximum efficiency.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const CloudConsultingMeta = {
      metaTitle: `Cloud Consulting Provider | AWS Cloud Services - Peerbits`,
      metaDescription: "Cloud consultants with 5+ years of experience. Reach us to accelerate your cloud adoption, design cloud strategy, cloud migration, cloud optimization & more.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const TechnologyStackMeta = {
      metaTitle: `Peerbits Expertise in Leveraging Cutting-edge Technologies Solutions`,
      metaDescription: "Peerbits possess expertise in the best mobile app, frontend, backend, database, automated testing services along with other latest technology stack.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HireMongodbDevelopersMeta = {
      metaTitle: `Hire Dedicated MongoDB Developers | Hire MongoDB Experts`,
      metaDescription: "Hire dedicated MongoDB developers from Peerbits who are highly skilled and experienced in developing top-notch solutions for your businesses across the world.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const AmazonWebServicesPartnershipMeta = {
      metaTitle: `Amazon Web Services Partnership - Peerbits`,
      metaDescription: "Partner with Peerbits for expert Amazon Web Services solutions. From consulting to development, we'll help you leverage the power of AWS for your business.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ExtendDedicatedDevelopmentTeamMeta = {
      metaTitle: `Extend Your Offshore Software Development Team with Peerbtis`,
      metaDescription: "Extend your own dedicated software development team by leveraging our staff augmentation services that will upgrade your development capabilities by many folds.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ScheduleMeetingMeta = {
      metaTitle: `Peerbits visiting Purtugal & italy- Let's schedule a meeting`,
      metaDescription: "Peerbits is going on a business trip to Portugal & Italy aiming to meet startups & entrepreneurs and help them grow their business with our technical expertise.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WhyOffshoreMeta = {
      metaTitle: `Benefits of Choosing Offshore remote Development Center`,
      metaDescription: "Leverage the benefits of offshore remote development with Peerbits'. Extend your team, Improve efficiency, reduce costs, and access global talent, with ease.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WhitepaperOnDemandApplication = {
      metaTitle: `Whitepaper: A Guide to On-demand Mobile App Development`,
      metaDescription: "Your roadmap to on-demand mobile app excellence awaits in our exclusive Whitepaper. Learn key techniques and principles for app development success.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const WhitepaperAutomotive = {
      metaTitle: `Whitepaper: Guide on Smart Vehicles, IoT, and Cloud Services`,
      metaDescription: "Learn about the intersection of smart vehicles, IoT, and cloud services in our comprehensive whitepaper. Explore the future of connected transportation.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const WhitepaperSmartHome = {
      metaTitle: `Whitepaper: Smart Home Solutions - IoT`,
      metaDescription: "Explore the future of Smart Home Solutions with our IoT Whitepaper. Explore cutting-edge technology and innovations in home automation. Download now!",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const WhitepaperSmartRetail = {
      metaTitle: `Whitepaper: Smart Retail Solutions`,
      metaDescription: "Discover innovative Smart Retail Solutions in our whitepaper. Explore cutting-edge technologies for enhancing retail efficiency. Download now!",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const WhitepaperLogistics = {
      metaTitle: `Whitepaper: A Complete Guide to IoT in Logistics - Peerbits`,
      metaDescription: "Learn all about the game-changing potential of IoT in logistics and stay ahead in the logistics industry through our detailed whitepaper.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const ManagedItServicesMeta = {
      metaTitle: `Managed IT Services provider - App & Cloud Management`,
      metaDescription: "Peerbits is a leading managed IT services provider, offering infrastructure, cloud, application, and end-user management to boost your business efficiency.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ProductEngineeringServicesMeta = {
      metaTitle: `Product Engineering Services Company | Peerbits`,
      metaDescription: "Peerbits is a trusted product engineering company in India, USA. We deliver advanced custom solutions to empower your business, people, and future.",
      ogImage: ProductEngineeringServicesOgImage,
      twitterImage: ProductEngineeringServicesOgImage
};

export const PHPWebDevelopmentMeta = {
      metaTitle: `Best PHP Web Development Company, PHP Development Services`,
      metaDescription: "Looking for PHP development services? Connect with Peerbits - a trusted PHP development company in India, USA to fuel your business growth at affordable rate.",
      ogImage: PHPWebDevelopmentOgImage,
      twitterImage: PHPWebDevelopmentOgImage
};

export const FrontendDevelopmentMeta = {
      metaTitle: `Frontend Development Company India, USA - Peerbits`,
      metaDescription: "Hire front-end developers for expert design and development of your website or application. Skilled in HTML, CSS, JavaScript and user experience design.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const MobileAppQualityAssuranceTestingServicesMeta = {
      metaTitle: `Automated Mobile Testing & Cross Platform Testing Services`,
      metaDescription: "Simplify mobile app testing and enhance its quality with our Automated & Cross Platform Testing Services. Stay ahead in the competitive digital landscape.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const BlockchainAppDevelopmentServicesMeta = {
      metaTitle: `Custom Blockchain App Development Services Company USA `,
      metaDescription: "Peerbits is a leading Blockchain App Development company USA. Offering various Custom Blockchain Development Services across industries to maximize productivity.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const TopMobileAppDevelopmentCompanyUSAMeta = {
      metaTitle: `Top-Notch Mobile App Development Company USA - Peerbits`,
      metaDescription: "Get top mobile app development services in the USA from Peerbits - We specialize in iOS and Android development, consultation, and maintenance. Visit our service page.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const UiUxDesignMeta = {
      metaTitle: `Top Mobile App UI Design Company India, USA - Peerbits`,
      metaDescription: "Peerbits - a trusted UI/UX design company in India, USA. We offer a range of UI/UX design services like app and web design, landing page design and more.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const GasDeliverySoftwareMeta = {
      metaTitle: `Gas Delivery Ordering Software, Best Gas Management Systems`,
      metaDescription: "Transform your gas delivery business with our cutting-edge gas management system. Reach a wider audience, improve efficiency, and boost your bottom line.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const FuelDeliverySoftwareMeta = {
      metaTitle: `On-demand Fuel App Delivery Services, Company - Peerbits`,
      metaDescription: "Streamline fuel delivery operations with our cutting-edge fuel delivery software. Enhance efficiency & accuracy, boost productivity and reduce cost.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WarehouseManagementSoftwareMeta = {
      metaTitle: `Warehouse Management Software |  Inventory Management System`,
      metaDescription: "Get the latest RFID technology in warehouse management with Peerbits. Our smart WMS solution streamlines operations, saves cost, & improves efficiency.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const OnDemandDeliveryAppDevelopmentMeta = {
      metaTitle: `On Demand Delivery Tracking App | On-Demand Dispatch Software`,
      metaDescription: "On Demand Delivery Software Solutions for courier, food delivery, field service and delivery companies to manage on demand dispatch system. Talk to expert now.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const OnDemandAppDevelopmentMeta = {
      metaTitle: `Top On Demand App Development company India, USA - Peerbits`,
      metaDescription: "Peerbits: A trusted on-demand app development company in India,USA. Get customized on-demand app development solutions for your holistic business growth.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const InternetOfThingsIotApplicationsMeta = {
      metaTitle: `IoT App Development Company USA, IoT development services`,
      metaDescription: "Peerbits - A leading IoT app development company specialized in developing innovative IoT apps. Transform your business with our IoT app development services.",
      ogImage: InternetOfThingsIotApplicationsOgImage,
      twitterImage: InternetOfThingsIotApplicationsOgImage
};

export const FullStackWebDevelopmentMeta = {
      metaTitle: `Best Full Stack Web Development Company India, USA - Peerbits`,
      metaDescription: "Peerbits is a full stack web development company providing a wide range of services, including front-end & back-end development, to deliver your dream website.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ThankyouMeta = {
      metaTitle: `Thank You for Contacting Us - Peerbits`,
      metaDescription: "Thank you for your interest. Our team is grateful for your approach and we appreciate your trust in our brand. Stay connected with us for future updates.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const RetailMobilitySolutionsMeta = {
      metaTitle: `Retail App Development Consulting & Solutions Company USA`,
      metaDescription: "Peerbits - A Leading retail app development company creating user-friendly and visually appealing mobile apps that provide a seamless shopping experience.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const OilAndGasIndustryAppSolutionMeta = {
      metaTitle: `Oil & Gas Mobile App Development Solutions - Peerbits`,
      metaDescription: "Peerbits is a leading oil & gas industry app development services provider in India, USA. We use intelligent tools & tech to deliver efficient solutions. ",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WellnessAndFitnessAppDevelopmentMeta = {
      metaTitle: `Wellness & Fitness App Development Services Company - Peerbits`,
      metaDescription: "Peerbits - A trusted wellness & fitness app development company have years of experience in creating custom wellness apps with modern technology.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const FinanceAppDevelopmentMeta = {
      metaTitle: `Finance Mobile App Development Company - Peerbits`,
      metaDescription: "Are you looking for a mobility solution to develop a financial, banking or insurance app. We are the solution providers for finance app of every type.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WearableAppDevelopmentMeta = {
      metaTitle: `Wearable App Development Solutions Company India, USA`,
      metaDescription: "Peerbits - A leading wearable app development company in India, USA. We develop top quality & bugfree wearable apps for iOS & Android at an affordable rate. ",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const CrossPlatformApplicationFrameworksMeta = {
      metaTitle: `Cross Platform App Development Company USA - Peerbits`,
      metaDescription: "Peerbits provides Cross platform app development services for various industries, using variety of frameworks that allows apps to be native to iOS and Android.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const SmartHomeAutomationSystemsMeta = {
      metaTitle: `IoT Smart Home Solutions | Home Automation System & Software`,
      metaDescription: "Redefine the way you live in your house with IoT home automation systems. Smart home solutions leverage the IoT technology to offer the comfort and convenience.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const SmartEnergySolutionMeta = {
      metaTitle: `Custom IoT based Smart Energy Monitoring System Development`,
      metaDescription: "Get customized smart energy solutions for your business from Peerbits. Reduce costs and improve efficiency with our IoT-based systems.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const LogisticsAppDevelopmentMeta = {
      metaTitle: `Logistic App Development Company | Fleet Management Solution`,
      metaDescription: "A leading Logistics App Development Company - Peerbits offer reliable logistics app development services that ensures high efficiency and sleek operations.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const LastMileDeliveryLogisticsManagementSoftwareMeta = {
      metaTitle: `Last Mile Delivery Logistics Management Software - Peerbits`,
      metaDescription: "Enhance your supply chain operations, boost your company's reputation, and improve delivery management with our reliable last mile delivery software.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const TransportationAppDevelopmentMeta = {
      metaTitle: `Transportation App Development Company | Mobility Solutions`,
      metaDescription: "Peerbits is a transportation app development company that provides cutting-edge mobility solutions to the transportation industry, delivering results of top quality.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HealthcareAppDevelopmentMeta = {
      metaTitle: `Healthcare App Development Services | mHealth Apps Solutions`,
      metaDescription: "Peerbits - A reliable healthcare app development company India, USA - creating mHealth solutions that meet the specific needs of healthcare organizations.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const HirePHPDevelopersPageMeta = {
      metaTitle: `Hire Dedicated PHP Developers | Hire PHP Experts`,
      metaDescription: "Get the finest PHP developers’ on hourly, monthly, and project-basis from Peerbits. We ensure using latest tools, timely delivery, and cost-effective approach.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ServicesMeta = {
      metaTitle: `Trusted Mobile App Development Services Company India, USA`,
      metaDescription: "Get top mobile app development services in USA from Peerbits. Our app design & development services include consultation, design, development, and maintenance.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const TopAppDevelopmentCompanyMeta = {
      metaTitle: `Blockchain, IoT & Software App Development Company - Peerbits`,
      metaDescription: "Peerbits - A top-tier Blockchain, IoT, and Software App Development Company. delivering cutting-edge solutions worldwide. Get access to experts in no time. ",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const AngularjsDevelopmentMeta = {
      metaTitle: `Best AngularJS Development Company India, USA - Peerbits`,
      metaDescription: "Peerbits, the best AngularJS Development Company in India & USA providing robust AngularJS Development Services for your specific business needs.",
      ogImage: AngularjsDevelopmentOgImage,
      twitterImage: AngularjsDevelopmentOgImage
};

export const PythonDevelopmentMeta = {
      metaTitle: `Custom Python Web & Software Development India, USA`,
      metaDescription: "Looking for a reliable Python development company? We build scalable apps & offer top-notch services that deliver high-quality results at an affordable rate.",
      ogImage: PythonDevelopmentOgImage,
      twitterImage: PythonDevelopmentOgImage
};

export const DotNetDevelopmentMeta = {
      metaTitle: `Dot Net Development Company USA | .Net Development Services`,
      metaDescription: "As a top dot net web development company USA, we are trusted to provide reliable .NET app development services to develop enterprise-grade software solutions.",
      ogImage: DotNetDevelopmentOgImage,
      twitterImage: DotNetDevelopmentOgImage
};

export const JavaDevelopmentMeta = {
      metaTitle: `Top Java Development Company | Java Development Services`,
      metaDescription: "As a leading Java development company - Peerbits offer end to end Java development services. Get reliable & scalable Java solutions for your business needs.",
      ogImage: JavaDevelopmentOgImage,
      twitterImage: JavaDevelopmentOgImage
};

export const MobileAppStrategyMeta = {
      metaTitle: `Best Mobile App Development Consulting Services - Peerbits`,
      metaDescription: "Get expert mobile app development strategies and consulting services from Peerbits. With our proven methods, we'll help you achieve your business goals.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const IphoneApplicationDevelopmentMeta = {
      metaTitle: `Top iPhone App Development Company India, USA - Peerbits`,
      metaDescription: "Peerbits is a top iPhone app development company in India, USA - building exceptional iPhone apps using latest tech for various industries at affordable rates.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const XamarinMobileApplicationDevelopmentMeta = {
      metaTitle: `Xamarin Mobile App Development Company India, USA - Peerbits`,
      metaDescription: "Peerbits - A top Xamarin app development company in India, USA. Trusted to deliver dynamic Xamarin app development services for cross-platform apps, globally.",
      ogImage: XamarinMobileApplicationDevelopmentOgImage,
      twitterImage: XamarinMobileApplicationDevelopmentOgImage
};

export const CaseStudiesMeta = {
      metaTitle: `Successful Mobile App Development and Design Case Studies`,
      metaDescription: "Read our top mobile app development and design case studies to discover how Peerbits help startups and enterprises to grow and expand businesses on Mobile.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ReactNativeDevelopmentMeta = {
      metaTitle: `Top React Native App Development Services Company - Peerbits`,
      metaDescription: "Peerbits - A reliable React Native app development company in India, USA. We offer full react native app development service to build cross platform mobile apps.",
      ogImage: ReactNativeDevelopmentOgImage,
      twitterImage: ReactNativeDevelopmentOgImage
};

export const ReactDevelopmentMeta = {
      metaTitle: `Trusted ReactJS Development Services Company India, USA`,
      metaDescription: "Looking for a top-rated React JS development company in India, USA? Contact Peerbits - A trusted ReactJS development services provider at an affordable rate.",
      ogImage: ReactDevelopmentOgImage,
      twitterImage: ReactDevelopmentOgImage
};

export const VuejsDevelopmentMeta = {
      metaTitle: `Vue JS Development Company | Vue.JS Development Services`,
      metaDescription: "Peerbits - the best VueJS development company India | USA, offer reliable Vue.js development services to create flawless & budget-friendly apps across industry.",
      ogImage: VuejsDevelopmentOgImage,
      twitterImage: VuejsDevelopmentOgImage
};

export const LaravelDevelopmentMeta = {
      metaTitle: `Laravel Development Company | Laravel Development Services`,
      metaDescription: "As a top laravel development company USA, we possess extensive expertise in laravel and provide complete laravel development services to build custom apps.",
      ogImage: LaravelDevelopmentOgImage,
      twitterImage: LaravelDevelopmentOgImage
};

export const FlutterAppDevelopmentMeta = {
      metaTitle: `Flutter App Development Company | Flutter Development Services`,
      metaDescription: "Peerbits - A top Flutter development company in USA. We provide custom app development services to build high-quality cross-platform apps at affordable rates.",
      ogImage: FlutterAppDevelopmentOgImage,
      twitterImage: FlutterAppDevelopmentOgImage
};

export const DjangoDevelopmentMeta = {
      metaTitle: `Django Software Development Company India, USA - Peerbits`,
      metaDescription: "Peerbits is a trusted Django development company USA expert in providing complete Django development services & building highly scalable yet stylish web apps.",
      ogImage: DjangoDevelopmentOgImage,
      twitterImage: DjangoDevelopmentOgImage
};

export const MeanStackDevelopmentMeta = {
      metaTitle: `Top MEAN Stack Development Company India, USA - Peerbits`,
      metaDescription: "Peerbits - A MEAN stack development company India, USA - help you craft powerful digital solutions that engage users, solve business pains & drive quick growth.",
      ogImage: MeanStackDevelopmentOgImage,
      twitterImage: MeanStackDevelopmentOgImage
};

export const MernStackDevelopmentMeta = {
      metaTitle: `Trusted MERN Stack Development Service Company - Peerbits`,
      metaDescription: "Peerbits is a leading MERN stack development company in India, USA trusted to develop feature-rich, interactive, robust, & scalable custom web apps.",
      ogImage: MernStackDevelopmentOgImage,
      twitterImage: MernStackDevelopmentOgImage
};

export const NodejsdevelopmentMeta = {
      metaTitle: `NodeJS Development Company | NodeJS Development Services`,
      metaDescription: "As a node js development company USA, we specialize in providing enterprise-grade node.js development services to all businesses sizes. Get a free quote now.",
      ogImage: NodejsdevelopmentOgImage,
      twitterImage: NodejsdevelopmentOgImage
};

export const SymfonyDevelopmentMeta = {
      metaTitle: `Custom Symfony Development Services Company - Peerbits`,
      metaDescription: "Peerbits is a reliable Symfony development company in India offering cost-effective Symfony development services at an affordable rate to global clients.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const PortugalStrategicPartnershipMeta = {
      metaTitle: `Schedule a Meeting with Our Portugal Technical Partners`,
      metaDescription: "Peerbits is now having its official physical presence in Portugal to help native businesses succeed. Meet our partners and discuss your business growth.",
      ogImage: PortugalStrategicPartnershipImage,
      twitterImage: PortugalStrategicPartnershipImage
};

export const OurClientsMeta = {
      metaTitle: `Our Esteemed Global Clients - Peerbits`,
      metaDescription: "Peerbits - Discover our esteemed global clients. A testament to our exceptional services, expertise, & successful partnerships across various industries.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const FinancialSoftwareDevelopmentMeta = {
      metaTitle: `Financial Software Development | Peerbits`,
      metaDescription: "Do you want to build a secure fintech app? We offer extensive Fintech software development that improves security and brings transparency to your firms.",
      ogImage: FinancialSoftwareDevelopmentOgImage,
      twitterImage: FinancialSoftwareDevelopmentOgImage
};

export const LogisticsSoftwareDevelopmentMeta = {
      metaTitle: `Logistics and Transportation Software Development Services`,
      metaDescription: "We build custom logistics and transportation software including TMS development, delivery and logistics automation solutions & more for a seamless supply chain.",
      ogImage: LogisticsSoftwareDevelopmentOgImage,
      twitterImage: LogisticsSoftwareDevelopmentOgImage
};

export const HealthcareSoftwareDevelopmentMeta = {
      metaTitle: `Custom Healthcare Development Company | Peerbits`,
      metaDescription: "We build software solutions for Healthcare industry, offering full product development services including web/app development & healthcare platform development.",
      ogImage: HealthcareSoftwareDevelopmentOgImage,
      twitterImage: HealthcareSoftwareDevelopmentOgImage
};

export const DigitalTransformationMeta = {
      metaTitle: `Digital Transformation Services Company - Peerbits`,
      metaDescription: "Peerbits offers a digital transformation (DX) consulting company helping businesses with our services to reimagine their models and achieve competitive advantage.",
      ogImage: DigitalTransformationOgImage,
      twitterImage: DigitalTransformationOgImage
};

export const SaasDevelopmentCompanyMeta = {
      metaTitle: `SaaS Product Development Services Company - Peerbits`,
      metaDescription: "Peerbits - A Leading SaaS Development Company in India, USA. From startups to enterprises, we offer 100% specialized SaaS application development services.",
      ogImage: SaasDevelopmentCompanyOgImage,
      twitterImage: SaasDevelopmentCompanyOgImage
};

export const MvpDevelopmentCompanyMeta = {
      metaTitle: `Top MVP Mobile and Web App Development Company - Peerbits`,
      metaDescription: "Peerbits is a top MVP development company with 11 years of IT experience, offering tailored solutions for startups & enterprises. Launch your MVP in 2-14 days.",
      ogImage: MvpDevelopmentCompanyOgImage,
      twitterImage: MvpDevelopmentCompanyOgImage
};

export const SoftwareDevelopmentCompanyPortugalMeta = {
      metaTitle: `Software Development Service Company in Portugal - Peerbits`,
      metaDescription: "Peerbits, a leading web, mobile and software development company, delivers out of the box solutions to the clients in Portugal. Get a free no obligation quote.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ApacheKafkaMeta = {
      metaTitle: `Apache Kafka Service: Real-Time Data Streaming Solutions`,
      metaDescription: "Discover the power of Apache Kafka service for seamless real-time data streaming & processing. Learn how to unlock full potential of data with Apache Kafka today.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const RedisMeta = {
      metaTitle: `Redis Services: Enhance Data Performance and Scalability`,
      metaDescription: "Unlock power of Redis with our services. Optimize data performance, scalability & reliability. Harness the potential of real-time data with our custom solutions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ElasticSearchMeta = {
      metaTitle: `Elasticsearch Services for Data Optimization and Analysis`,
      metaDescription: "Harness Elasticsearch's potential to organize, analyze, and visualize your data like never before. Optimize your data-driven decisions with us.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const ApacheFlinkMeta = {
      metaTitle: `Empower Your Data Processing with Apache Flink Services`,
      metaDescription: "Discover top-tier Apache Flink services tailored to optimize data processing efficiency. Our experts at Peerbits deliver cutting-edge solutions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const DatadogMonitoringServicesMeta = {
      metaTitle: `DataDog Services | Monitor, Analyze & Optimize Your Systems`,
      metaDescription: "Explore DataDog's comprehensive suite of services to monitor, analyze, and optimize your infrastructure, applications, and logs.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const DockerandkubernetesMeta = {
      metaTitle: `Accelerate Development: Unleash Power of Docker & Kubernetes`,
      metaDescription: "Discover the agility of development with Docker and Kubernetes. Harness containerization and orchestration for seamless deployment, scalability, and efficiency.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const RemotePatientMonitoringSolutionsMeta = {
      metaTitle: `Remote Patient Monitoring Solutions Company | Peerbits`,
      metaDescription: "Our remote patient monitoring solutions help doctors & patients. We are a leading RPM software development agency helping our clients with the best solutions.",
      ogImage: RemotePatientMonitoringSolutionsOgImage,
      twitterImage: RemotePatientMonitoringSolutionsOgImage
};
export const PatientEngagementSoftwareDevelopmentMeta = {
      metaTitle: `Patient engagement software solutions development - Peerbits`,
      metaDescription: "Peerbits develops custom patient engagement software solutions & apps to empower healthcare providers to offer more integrated & patient-centric care delivery.",
      ogImage: PatientEngagementSoftwareDevelopmentOgImage,
      twitterImage: PatientEngagementSoftwareDevelopmentOgImage
};
export const PatientRegistrySoftwareDevelopmentMeta = {
      metaTitle: `Seamless Patient Registry Software Development Services`,
      metaDescription: "Go beyond basic registries! At Peerbits, We craft secure & custom patient registry software. Build powerful,HIPAA-compliant solutions for research & quality improvement.",
      ogImage: PatientRegistrySoftwareDevelopmentOgImage,
      twitterImage: PatientRegistrySoftwareDevelopmentOgImage
};
export const TelemedicineAppDevelopmentMeta = {
      metaTitle: `Best Healthcare with our Telemedicine App Development`,
      metaDescription: "Peerbits is dedicatedly working for healthcare software development since last 14+ years. We help businesses to build scalable world-class softwares",
      ogImage: TelemedicineAppDevelopmentOgImage,
      twitterImage: TelemedicineAppDevelopmentOgImage
};
export const HealthcareIotSolutionsMeta = {
      metaTitle: `Healthcare IoT Solutions for Businesses`,
      metaDescription: "The integration of healthcare and IoT has been a strength of Peerbits since long. We are climbing peaks with our 14+ years healthcare IoT experience",
      ogImage: HealthcareIotSolutionsOgImage,
      twitterImage: HealthcareIotSolutionsOgImage
};
export const MhealthappMeta = {
      metaTitle: `Expert mHealth App Development Services by Peerbits`,
      metaDescription: "Experience our easy-to-use mHealth app development. From remote monitoring to health tracking, our solutions are designed for simplicity and security. Connect to experience the healthcare transformation.",
      ogImage: MhealthappOgImage,
      twitterImage: MhealthappOgImage
};
export const EwalletappdevelopmentMeta = {
      metaTitle: `Develop your E-Wallet App: Seamless Development Solutions`,
      metaDescription: "Smoothen your digital transactions with Peerbits' easy-to-use e-wallet app development services. Our secure and user-friendly solutions are designed to make financial management easy.",
      ogImage: EwalletappdevelopmentOgImage,
      twitterImage: EwalletappdevelopmentOgImage
};
export const MobilebankingMeta = {
      metaTitle: `Create Mobile Banking App with Our Expert Development Services`,
      metaDescription: "Experience banking on your fingertips. Peerbits' mobile banking app development solutions provide secure, user-friendly options customized for your bank. Explore the convenience.",
      ogImage: MobilebankingOgImage,
      twitterImage: MobilebankingOgImage
};
export const MerchantPaymentServicesMeta = {
      metaTitle: `Get Secured Merchant Payment Services with Peerbits`,
      metaDescription: "Want to power up your business with robust merchant payment services? Build hassle-free payment experience for client satisfaction and loyalty. Let’s discuss!",
      ogImage: MerchantPaymentServicesOgImage,
      twitterImage: MerchantPaymentServicesOgImage
};

export const CrossBorderRemittanceSoftwareDevelopmentMeta = {
      metaTitle: `Transform Your Remittance Process with Adept Cross-Border Remittance Software Development`,
      metaDescription: "Experience smooth international fund transfers with Peerbits' cross-border remittance software development services. Optimize security and compliance today.",
      ogImage: CrossBorderRemittanceSoftwareDevelopmentOgImage,
      twitterImage: CrossBorderRemittanceSoftwareDevelopmentOgImage
};

